import tours from './tours';

export const ONBOARD_CHATBOTS = tours.ONBOARD_CHATBOTS

